import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'
import { BREAKPOINT } from 'app/sofia/resources/constants'

export const Container = styled.div`
  width: 100%;

  @media (max-width: ${BREAKPOINT.MD}) {
    width: 65%;
  }

  ${bp('sm')`
    width: 100%;
  `}

  .footer__legal {
    display: flex;

    @media (max-width: ${BREAKPOINT.MD}) {
      flex-wrap: wrap;
      margin: 0;
    }

    ${bp('sm')`
      flex-direction: column;
    `}

    > li {
      &:not(:last-child) {
        margin-right: 8%;
      }

      a {
        ${bp('sm')`
          display: block;
          padding: 10px 0;
        `}
      }
    }
  }
`
